export const state = {
  trucktrackings: [],
  systemTrucktracking: []
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/trucktrackings/state.js